import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, ListItemText } from '@material-ui/core';

const CompanyList = props => {
  const { menuitems, companyChange, className, ...rest } = props;

  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
      disablePadding
    >
      {menuitems.map((menu, i) => (
        <ListItem
          className={classes.listItem}
          divider={i < menuitems.length - 1}
          key={menu.id}
          onClick={() => companyChange(menu)}
        >
          <ListItemText
            primary={menu.companyName}
            primaryTypographyProps={{ variant: 'body1' }}
          />
        </ListItem>
      ))}
    </List>
  );
};

CompanyList.propTypes = {
  className: PropTypes.string,
  menuitems: PropTypes.array.isRequired
};

export default CompanyList;

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      cursor: 'pointer'
    }
  }
}));
